import { render, staticRenderFns } from "./AgencyDetail.vue?vue&type=template&id=22231285&scoped=true&"
import script from "./AgencyDetail.vue?vue&type=script&lang=js&"
export * from "./AgencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgencyDetail.vue?vue&type=style&index=0&id=22231285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22231285",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22231285')) {
      api.createRecord('22231285', component.options)
    } else {
      api.reload('22231285', component.options)
    }
    module.hot.accept("./AgencyDetail.vue?vue&type=template&id=22231285&scoped=true&", function () {
      api.rerender('22231285', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/agency/AgencyDetail.vue"
export default component.exports